export const selectShop = state => state.shop;
